import React, { Component } from "react";

import AutoCompleteInputBlockToAdd from "./autoCompleteInputBlockToAdd/autoCompleteInputBlockToAdd";

import BufferedNumberInput from "./bufferedNumberInput/bufferedNumberInput";

import Tooltip from "../tooltip";

import BackgroundColourModes from "./json/backgroundColourModes.json";
import CropModes from "./json/cropModes.json";
import DitherMethods from "./json/ditherMethods.json";
import MapModes from "./json/mapModes.json";
import SupportedVersions from "./json/supportedVersions.json";
import WhereSupportBlocksModes from "./json/whereSupportBlocksModes.json";

import "./mapSettings.css";

class MapSettings extends Component {
  render() {
    const {
      getLocaleString,
      coloursJSON,
      optionValue_version,
      onOptionChange_version,
      optionValue_mapSize_x,
      onOptionChange_mapSize_x,
      optionValue_mapSize_y,
      onOptionChange_mapSize_y,
      optionValue_modeNBTOrMapdat,
      onOptionChange_modeNBTOrMapdat,
      optionValue_cropImage,
      onOptionChange_cropImage,
      optionValue_cropImage_zoom,
      onOptionChange_cropImage_zoom,
      optionValue_cropImage_percent_x,
      onOptionChange_cropImage_percent_x,
      optionValue_cropImage_percent_y,
      onOptionChange_cropImage_percent_y,
      optionValue_showGridOverlay,
      onOptionChange_showGridOverlay,
      optionValue_staircasing,
      onOptionChange_staircasing,
      optionValue_whereSupportBlocks,
      onOptionChange_WhereSupportBlocks,
      optionValue_supportBlock,
      setOption_SupportBlock,
      optionValue_transparency,
      onOptionChange_transparency,
      optionValue_transparencyTolerance,
      onOptionChange_transparencyTolerance,
      optionValue_accountForNoobLine,
      onOptionChange_accountForNoobLine,
      optionValue_mapdatFilenameUseId,
      onOptionChange_mapdatFilenameUseId,
      optionValue_mapdatFilenameIdStart,
      onOptionChange_mapdatFilenameIdStart,
      optionValue_betterColour,
      onOptionChange_BetterColour,
      optionValue_dithering,
      onOptionChange_dithering,
      optionValue_preprocessingEnabled,
      onOptionChange_PreProcessingEnabled,
      preProcessingValue_brightness,
      onOptionChange_PreProcessingBrightness,
      preProcessingValue_contrast,
      onOptionChange_PreProcessingContrast,
      preProcessingValue_saturation,
      onOptionChange_PreProcessingSaturation,
      preProcessingValue_backgroundColourSelect,
      onOptionChange_PreProcessingBackgroundColourSelect,
      preProcessingValue_backgroundColour,
      onOptionChange_PreProcessingBackgroundColour,
      optionValue_extras_moreStaircasingOptions,
      onOptionChange_extras_moreStaircasingOptions,
    } = this.props;

    const shouldShowNoobLineSetting =
      optionValue_mapSize_y > 1 &&
      optionValue_staircasing === MapModes.SCHEMATIC_NBT.staircaseModes.OFF.uniqueId &&
      optionValue_modeNBTOrMapdat === MapModes.SCHEMATIC_NBT.uniqueId;

    const isManualCrop = optionValue_cropImage === CropModes.MANUAL.uniqueId;
    const isNBTMode = optionValue_modeNBTOrMapdat === MapModes.SCHEMATIC_NBT.uniqueId;

    return (
      <div className="section settingsDiv">
        <h2>{getLocaleString("MAP-SETTINGS/TITLE")}</h2>
        <div className="settingsGrid">

          {/* Mode */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/MODE-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/MODE")}:</span>
          </Tooltip>
          <div className="settingValue">
            <select onChange={onOptionChange_modeNBTOrMapdat} value={optionValue_modeNBTOrMapdat}>
              {Object.values(MapModes).map((mapMode) => (
                <option key={mapMode.uniqueId} value={mapMode.uniqueId}>
                  {mapMode.name}
                </option>
              ))}
            </select>
          </div>

          {/* Version */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/VERSION-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/VERSION")}:</span>
          </Tooltip>
          <div className="settingValue">
            <select value={optionValue_version.MCVersion} onChange={onOptionChange_version}>
              {Object.values(SupportedVersions).map((supportedVersion) => (
                <option key={supportedVersion.MCVersion} value={supportedVersion.MCVersion}>
                  {supportedVersion.MCVersion}
                </option>
              ))}
            </select>
          </div>

          {/* Map Size */}
          <span className="settingLabel">{getLocaleString("MAP-SETTINGS/MAP-SIZE")}:</span>
          <div className="settingValue">
            <BufferedNumberInput
              min="1"
              max={null}
              step="1"
              value={optionValue_mapSize_x}
              validators={[(t) => !isNaN(t), (t) => t > 0]}
              onValidInput={onOptionChange_mapSize_x}
              style={{ width: "2.5em" }}
            />
            <span>×</span>
            <BufferedNumberInput
              min="1"
              max={null}
              step="1"
              value={optionValue_mapSize_y}
              validators={[(t) => !isNaN(t), (t) => t > 0]}
              onValidInput={onOptionChange_mapSize_y}
              style={{ width: "2.5em" }}
            />
          </div>

          {/* Crop */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/CROP/TITLE-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/CROP/TITLE")}:</span>
          </Tooltip>
          <div className="settingValue">
            <select onChange={onOptionChange_cropImage} value={optionValue_cropImage}>
              {Object.values(CropModes).map((cropMode) => (
                <option key={cropMode.uniqueId} value={cropMode.uniqueId}>
                  {getLocaleString(cropMode.localeKey)}
                </option>
              ))}
            </select>
          </div>

          {/* Manual Crop Controls */}
          {isManualCrop && (
            <React.Fragment>
              <span className="settingLabel">{getLocaleString("MAP-SETTINGS/CROP/ZOOM")}:</span>
              <div className="settingValue">
                <input
                  type="range"
                  min="10"
                  max="50"
                  value={optionValue_cropImage_zoom}
                  onChange={(e) => onOptionChange_cropImage_zoom(parseInt(e.target.value))}
                  style={{ width: "120px" }}
                />
              </div>
              <span className="settingLabel">X:</span>
              <div className="settingValue">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={optionValue_cropImage_percent_x}
                  onChange={(e) => onOptionChange_cropImage_percent_x(parseInt(e.target.value))}
                  style={{ width: "100px" }}
                />
                <BufferedNumberInput
                  min="0"
                  max="100"
                  step="1"
                  value={optionValue_cropImage_percent_x}
                  validators={[(t) => !isNaN(t), (t) => t >= 0, (t) => t <= 100]}
                  onValidInput={onOptionChange_cropImage_percent_x}
                  style={{ width: "3em" }}
                />
              </div>
              <span className="settingLabel">Y:</span>
              <div className="settingValue">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={optionValue_cropImage_percent_y}
                  onChange={(e) => onOptionChange_cropImage_percent_y(parseInt(e.target.value))}
                  style={{ width: "100px" }}
                />
                <BufferedNumberInput
                  min="0"
                  max="100"
                  step="1"
                  value={optionValue_cropImage_percent_y}
                  validators={[(t) => !isNaN(t), (t) => t >= 0, (t) => t <= 100]}
                  onValidInput={onOptionChange_cropImage_percent_y}
                  style={{ width: "3em" }}
                />
              </div>
            </React.Fragment>
          )}

          {/* Grid Overlay */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/GRID-OVERLAY-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/GRID-OVERLAY")}:</span>
          </Tooltip>
          <div className="settingValue">
            <input type="checkbox" checked={optionValue_showGridOverlay} onChange={onOptionChange_showGridOverlay} />
          </div>

          {/* Staircasing */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/3D/TITLE-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/3D/TITLE")}:</span>
          </Tooltip>
          <div className="settingValue">
            <select onChange={onOptionChange_staircasing} value={optionValue_staircasing}>
              {Object.values(
                isNBTMode ? MapModes.SCHEMATIC_NBT.staircaseModes : MapModes.MAPDAT.staircaseModes
              )
                .filter((staircaseMode) => optionValue_extras_moreStaircasingOptions || !staircaseMode.extra)
                .map((staircaseMode) => (
                  <option key={staircaseMode.uniqueId} value={staircaseMode.uniqueId}>
                    {getLocaleString(staircaseMode.localeKey)}
                  </option>
                ))}
            </select>
          </div>

          {/* More Staircasing Options */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/EXTRAS/MORE-STAIRCASING-OPTIONS-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/EXTRAS/MORE-STAIRCASING-OPTIONS")}:</span>
          </Tooltip>
          <div className="settingValue">
            <input type="checkbox" checked={optionValue_extras_moreStaircasingOptions} onChange={onOptionChange_extras_moreStaircasingOptions} />
          </div>

          {/* Transparency */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/MAPDAT-SPECIFIC/TRANSPARENCY-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/MAPDAT-SPECIFIC/TRANSPARENCY")}:</span>
          </Tooltip>
          <div className="settingValue">
            <input type="checkbox" checked={optionValue_transparency} onChange={onOptionChange_transparency} />
          </div>

          {/* Transparency Tolerance */}
          {optionValue_transparency && (
            <React.Fragment>
              <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/MAPDAT-SPECIFIC/TRANSPARENCY-TOLERANCE-TT")}>
                <span className="settingLabel">{getLocaleString("MAP-SETTINGS/MAPDAT-SPECIFIC/TRANSPARENCY-TOLERANCE")}:</span>
              </Tooltip>
              <div className="settingValue">
                <input
                  type="range"
                  min="1"
                  max="255"
                  value={optionValue_transparencyTolerance}
                  onChange={(e) => onOptionChange_transparencyTolerance(parseInt(e.target.value))}
                  style={{ width: "120px" }}
                />
                <span>{optionValue_transparencyTolerance}</span>
              </div>
            </React.Fragment>
          )}

          {/* Account for Noob Line */}
          {shouldShowNoobLineSetting && (
            <React.Fragment>
              <Tooltip tooltipText="Adds an extra row to non-top segments to account for Minecraft map rendering spacing">
                <span className="settingLabel">Account for Noob Line:</span>
              </Tooltip>
              <div className="settingValue">
                <input type="checkbox" checked={optionValue_accountForNoobLine} onChange={onOptionChange_accountForNoobLine} />
              </div>
            </React.Fragment>
          )}

          <hr className="settingsDivider" />

          {/* Mode-specific settings */}
          {isNBTMode ? (
            <React.Fragment>
              {/* Add blocks under */}
              <span className="settingLabel">{getLocaleString("MAP-SETTINGS/NBT-SPECIFIC/WHERE-SUPPORT-BLOCKS/TITLE")}:</span>
              <div className="settingValue">
                <select value={optionValue_whereSupportBlocks} onChange={onOptionChange_WhereSupportBlocks}>
                  {Object.values(WhereSupportBlocksModes).map((whereSupportBlocksMode) => (
                    <option key={whereSupportBlocksMode.uniqueId} value={whereSupportBlocksMode.uniqueId}>
                      {getLocaleString(whereSupportBlocksMode.localeKey)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Noob Line (Block to add) */}
              <span className="settingLabel">{getLocaleString("MAP-SETTINGS/NBT-SPECIFIC/SUPPORT-BLOCK-TO-ADD")}:</span>
              <div className="settingValue">
                <AutoCompleteInputBlockToAdd
                  coloursJSON={coloursJSON}
                  value={optionValue_supportBlock}
                  setValue={setOption_SupportBlock}
                  optionValue_version={optionValue_version}
                />
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* Mapdat filename settings */}
              <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/MAPDAT-SPECIFIC/MAPDAT-FILENAME-USE-ID-TT")}>
                <span className="settingLabel">{getLocaleString("MAP-SETTINGS/MAPDAT-SPECIFIC/MAPDAT-FILENAME-USE-ID")}:</span>
              </Tooltip>
              <div className="settingValue">
                <input type="checkbox" checked={optionValue_mapdatFilenameUseId} onChange={onOptionChange_mapdatFilenameUseId} />
              </div>
              {optionValue_mapdatFilenameUseId && (
                <React.Fragment>
                  <span className="settingLabel">{getLocaleString("MAP-SETTINGS/MAPDAT-SPECIFIC/MAPDAT-FILENAME-ID-RANGE")}:</span>
                  <div className="settingValue">
                    <BufferedNumberInput
                      min="0"
                      step="1"
                      value={optionValue_mapdatFilenameIdStart}
                      validators={[(t) => !isNaN(t), (t) => t >= 0]}
                      onValidInput={onOptionChange_mapdatFilenameIdStart}
                      style={{ width: "3em" }}
                    />
                    <span>—</span>
                    <BufferedNumberInput
                      value={-1 + optionValue_mapdatFilenameIdStart + optionValue_mapSize_x * optionValue_mapSize_y}
                      disabled={true}
                      style={{ width: "3em" }}
                    />
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}

          <hr className="settingsDivider" />

          {/* Better Color */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/BETTER-COLOUR-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/BETTER-COLOUR")}:</span>
          </Tooltip>
          <div className="settingValue">
            <input type="checkbox" checked={optionValue_betterColour} onChange={onOptionChange_BetterColour} />
          </div>

          {/* Dithering */}
          <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/DITHERING/TITLE-TT")}>
            <span className="settingLabel">{getLocaleString("MAP-SETTINGS/DITHERING/TITLE")}:</span>
          </Tooltip>
          <div className="settingValue">
            <select value={optionValue_dithering} onChange={onOptionChange_dithering}>
              {Object.keys(DitherMethods).map((ditherMethodKey) => (
                <option key={DitherMethods[ditherMethodKey]["uniqueId"]} value={DitherMethods[ditherMethodKey]["uniqueId"]}>
                  {"localeKey" in DitherMethods[ditherMethodKey]
                    ? getLocaleString(DitherMethods[ditherMethodKey]["localeKey"])
                    : DitherMethods[ditherMethodKey]["name"]}
                </option>
              ))}
            </select>
          </div>

          {/* Image Preprocessing */}
          <div className="settingsDetails">
            <details>
              <summary>{getLocaleString("MAP-SETTINGS/PREPROCESSING/TITLE")}</summary>
              <div className={optionValue_preprocessingEnabled ? "settingsGroup" : null}>
                <div className="preprocessingGrid">
                  <label>{getLocaleString("MAP-SETTINGS/PREPROCESSING/ENABLE")}:</label>
                  <span />
                  <input type="checkbox" checked={optionValue_preprocessingEnabled} onChange={onOptionChange_PreProcessingEnabled} />

                  <label>{getLocaleString("MAP-SETTINGS/PREPROCESSING/BRIGHTNESS")}:</label>
                  <input
                    type="range"
                    min="0"
                    max="200"
                    value={preProcessingValue_brightness}
                    onChange={(e) => onOptionChange_PreProcessingBrightness(parseInt(e.target.value))}
                    disabled={!optionValue_preprocessingEnabled}
                  />
                  <BufferedNumberInput
                    min="0"
                    max="200"
                    step="1"
                    value={preProcessingValue_brightness}
                    validators={[(t) => !isNaN(t), (t) => t >= 0, (t) => t <= 200]}
                    onValidInput={onOptionChange_PreProcessingBrightness}
                    disabled={!optionValue_preprocessingEnabled}
                    style={{ width: "3em" }}
                  />

                  <label>{getLocaleString("MAP-SETTINGS/PREPROCESSING/CONTRAST")}:</label>
                  <input
                    type="range"
                    min="0"
                    max="200"
                    value={preProcessingValue_contrast}
                    onChange={(e) => onOptionChange_PreProcessingContrast(parseInt(e.target.value))}
                    disabled={!optionValue_preprocessingEnabled}
                  />
                  <BufferedNumberInput
                    min="0"
                    max="200"
                    step="1"
                    value={preProcessingValue_contrast}
                    validators={[(t) => !isNaN(t), (t) => t >= 0, (t) => t <= 200]}
                    onValidInput={onOptionChange_PreProcessingContrast}
                    disabled={!optionValue_preprocessingEnabled}
                    style={{ width: "3em" }}
                  />

                  <label>{getLocaleString("MAP-SETTINGS/PREPROCESSING/SATURATION")}:</label>
                  <input
                    type="range"
                    min="0"
                    max="200"
                    value={preProcessingValue_saturation}
                    onChange={(e) => onOptionChange_PreProcessingSaturation(parseInt(e.target.value))}
                    disabled={!optionValue_preprocessingEnabled}
                  />
                  <BufferedNumberInput
                    min="0"
                    max="200"
                    step="1"
                    value={preProcessingValue_saturation}
                    validators={[(t) => !isNaN(t), (t) => t >= 0, (t) => t <= 200]}
                    onValidInput={onOptionChange_PreProcessingSaturation}
                    disabled={!optionValue_preprocessingEnabled}
                    style={{ width: "3em" }}
                  />

                  <Tooltip tooltipText={getLocaleString("MAP-SETTINGS/PREPROCESSING/BACKGROUND/TITLE-TT")}>
                    <label>{getLocaleString("MAP-SETTINGS/PREPROCESSING/BACKGROUND/TITLE")}:</label>
                  </Tooltip>
                  <select
                    onChange={onOptionChange_PreProcessingBackgroundColourSelect}
                    value={preProcessingValue_backgroundColourSelect}
                    disabled={!optionValue_preprocessingEnabled}
                  >
                    {Object.values(BackgroundColourModes).map((backgroundColourMode) => (
                      <option key={backgroundColourMode.uniqueId} value={backgroundColourMode.uniqueId}>
                        {getLocaleString(backgroundColourMode.localeKey)}
                      </option>
                    ))}
                  </select>
                  <span />

                  <label>{getLocaleString("MAP-SETTINGS/PREPROCESSING/BACKGROUND-COLOUR")}:</label>
                  <input
                    type="color"
                    value={preProcessingValue_backgroundColour}
                    onChange={onOptionChange_PreProcessingBackgroundColour}
                    disabled={!optionValue_preprocessingEnabled || preProcessingValue_backgroundColourSelect === BackgroundColourModes.OFF.uniqueId}
                  />
                  <span />
                </div>
              </div>
            </details>
          </div>

        </div>
      </div>
    );
  }
}

export default MapSettings;
